// 评论模型
import { useState } from "react"
import { getDetailByUserIds } from "@/services/apis/aiwriter"
import Cookies from 'js-cookie'
interface IUserInfo {
  nickname: string
  portrait: string
}

const useCommentModel = () => {
  const [userInfo, setUserInfo] = useState<IUserInfo | null>(null)
  const [commentActiveId, setCommentActiveId] = useState<string>('')
  const [commentIds, setCommentIds] = useState<string[]>([])
  const [globalCommentId, setGlobalCommentId] = useState<string>('')
  // 获取用户信息
  const getUserInfo = async () => {
    const userId = Cookies.get('userid')!
    const data = await getDetailByUserIds({
      userIds: [userId],
    })
    setUserInfo(data?.[0])
  }

  // 生成随机的commentId， 规则是当前时间戳+六位随机数
  const generateCommentId = () => {
    const timestamp = Date.now()
    const random = Math.floor(Math.random() * 1000000)
    return `${timestamp}${random}`
  }

  return {
    userInfo,
    getUserInfo,
    commentIds,
    setCommentIds,
    generateCommentId,
    globalCommentId,
    setGlobalCommentId,
    setCommentActiveId,
    commentActiveId
  }
}

export default useCommentModel
